// REACT IMPORTS
import { useState, useEffect } from "react";

// AMPLITUDE
import * as amplitude from "@amplitude/analytics-browser";

// STYLES
import "./App.css";
const augioFullLogo = "/brand_marks/Augio_FullType_Logo_latest.png";

// COMPONENTS
import {Toolbar} from "./components/Toolbar";
import {TrendingCharts} from "./components/TrendingCharts";
import {TrendingRegions} from "./components/TrendingRegions";
import {Top100Preview} from "./components/Top100Preview";
import {TrendingArtists} from "./components/TrendingArtists";
import {GenrePills} from "./components/GenrePills";
import {NewArtists} from "./components/NewArtists";
import {RecentlyAdded} from "./components/RecentlyAdded";
import {UpvotedTracks} from "./components/UpvotedTracks";
import {Footer} from "./components/Footer";

export const App = () => {
  useEffect(() => {
    amplitude.track("home_view", {
      platform: "web",
      page_title: "Landing Page",
    });
  }, []);

  return (
    <div className="app-container">
      <Toolbar />

      <main className="main-content">
        <header className="page-header">
          <img className="augio-full-logo" src={augioFullLogo} />
          <h1 className="landing-header">DISCOVER WHAT'S NEXT</h1>
          <p className="landing-subheader">
            The future of independent music, organized for discovery.
          </p>
        </header>

        <TrendingCharts />

        <TrendingRegions />

        <Top100Preview />

        <RecentlyAdded />

        <TrendingArtists />

        <GenrePills />

        <NewArtists />

        <UpvotedTracks />

        <Footer />
      </main>
    </div>
  );
};